import React from 'react'
import './Projects.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

const Project = ({currentProject}) => {
    return (
        <>
            <div className='row p-lg-5 bg-light my-5'>
                <div class="col-lg-5 col-md-10 col-sm-10 col-12 mx-auto rotate d-flex align-items-center justify-content-center">
                    <img src={currentProject.Image} alt='dummy' max-height={'100%'} width={'100%'} />
                </div>


                <div class="col-lg-5 col-md-10 col-sm-10 col-10 mt-lg-0 mt-5 mx-auto text-start">
                    <h1>{currentProject.title}</h1>
                    <div className='mt-3'>
                        <a className='text-decoration-none' href={currentProject.githubLink} target={'_blank'} rel="noreferrer" style={{ textAlign: 'left' }}><FontAwesomeIcon icon={faGithub} beatFade size="2xl" /></a>

                        {
                            currentProject.liveLink && <a className='text-decoration-none  mx-3' href={currentProject.liveLink} target={'_blank'} rel="noreferrer" style={{ textAlign: 'left' }}><FontAwesomeIcon icon={faGlobe} spin size="2xl" style={{color: "#B197FC",}} /></a>
                        }
                        {/* <p><b>Status : </b>{currentProject.status}</p> */}
                    </div>
                    <div className='mt-4'>
                        <h3 >Tools</h3>
                        <div className='mt-2'>
                            {
                            currentProject.tools && 
                            currentProject.tools.map((tool) => <p key={tool} className='mx-2' style={{ backgroundColor: '#f2f0eb', display: 'inline-block' }}><span className="badge badge-light text-black">{tool}</span></p>)
                            }
                        </div>
                        
                        <p className='blockquote' style={{ color: '#969592' }}>{currentProject.description}</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Project
